import React from 'react'
import PropTypes from 'prop-types'
import InputWrapper from 'Components/InputWrapper'

const InputElement = ({ multiline, ...extraProps }) =>
  multiline ? <textarea {...extraProps} /> : <input {...extraProps} />

InputElement.propTypes = {
  multiline: PropTypes.bool.isRequired,
}

const CustomTextField = ({
  type,
  value,
  name,
  label,
  fullWidth,
  onChange,
  onBlur,
  placeholder,
  helperText,
  topSpacing, // use here to not pass to input in extraprops
  bottomSpacing,
  variant,
  errorText,
  multiline,
  startAdornment,
  endAdornment,
  style, // to disable passing style to input
  ...extraProps
}) => {
  return (
    <InputWrapper
      topSpacing={topSpacing}
      bottomSpacing={bottomSpacing}
      label={label}
      helperText={helperText}
      errorText={errorText}
      input={
        <span
          className={`flex items-center text-base rounded-xl shadow border border-solid border-gray-200 ${
            variant === 'dark' ? 'bg-gray-100' : 'bg-white'
          } focus-within:shadow-md focus-within:ring-blue-600 focus-within:ring-2`}
        >
          {Boolean(startAdornment) && (
            <span className="ml-4 flex items-center">{startAdornment}</span>
          )}
          {/* roundedxl match parent rounded to avoid mismatch for things like autofilled text style */}
          <InputElement
            type={type}
            placeholder={placeholder}
            name={name}
            className="flex-1 border rounded-xl py-3 px-4 border-transparent outline-none bg-transparent no-underline focus:border-transparent"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            multiline={multiline}
            {...extraProps}
          />
          {Boolean(endAdornment) && (
            <span className="mr-4 flex items-center">{endAdornment}</span>
          )}
        </span>
      }
    />
  )
}

CustomTextField.defaultProps = {
  onBlur: () => {},
  type: 'text',
  variant: 'dark',
  style: {},
  errorText: '',
  helperText: '',
  label: '',
  topSpacing: 0,
  bottomSpacing: 2,
  fullWidth: true,
  placeholder: '',
  value: undefined,
  multiline: false,
  startAdornment: null,
  endAdornment: null,
}

CustomTextField.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['light', 'dark']),
  type: PropTypes.string,
  onBlur: PropTypes.func,
  label: PropTypes.any,
  fullWidth: PropTypes.bool,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  errorText: PropTypes.any,
  helperText: PropTypes.any,
  topSpacing: PropTypes.number,
  bottomSpacing: PropTypes.number,
  value: PropTypes.any,
  multiline: PropTypes.bool,
  startAdornment: PropTypes.any,
  endAdornment: PropTypes.any,
}

export default CustomTextField
